const setLocalShowKOTButton = (val) => {
  localStorage.setItem("showKOTButton", val);
};
export default setLocalShowKOTButton;
